import { Fragment } from 'react';
import cards from '~/assets/icons/cards_2.svg';
import { CurrencyIcon } from '~/components/collections';
import { useWalletIcon } from '~/hooks';
import { rage, useObservable } from '~/rage';
import { Currency, WalletType } from '~/shared';
import { Text } from '../Text';
import {
	StyledContainer,
	StyledDivider,
	StyledPlayerStatsContainer,
} from './ShopBalance.styled';

interface ShopBalanceProps {
	walletTypes?: WalletType[];
	transparent?: boolean;
}

const ShopBalance: React.FC<ShopBalanceProps> = ({
	walletTypes = [WalletType.Donate, WalletType.Cash, WalletType.Bank],
	transparent = false,
}) => {
	const cashBalance = useObservable(rage.bank.getBalance(WalletType.Cash));
	const bankBalance = useObservable(rage.bank.getBalance(WalletType.Bank));
	const donateBalance = useObservable(rage.bank.getBalance(WalletType.Donate));

	const rubleIcon = useWalletIcon(Currency.Ruble, true);
	const donateIcon = useWalletIcon(Currency.Donate, true);

	const balanceConfig = {
		[WalletType.Cash]: {
			balance: cashBalance,
			icon: rubleIcon,
			currency: Currency.Ruble,
		},
		[WalletType.Bank]: {
			balance: bankBalance,
			icon: cards,
			currency: Currency.Ruble,
		},
		[WalletType.Donate]: {
			balance: donateBalance,
			icon: donateIcon,
			currency: Currency.Donate,
		},
	};

	return (
		<StyledContainer>
			<StyledPlayerStatsContainer $transparent={transparent}>
				{walletTypes.map((walletType, index) => {
					const config = balanceConfig[walletType];
					if (!config) return null;

					return (
						<Fragment key={walletType}>
							{index > 0 && <StyledDivider />}
							<Text>{config.balance.toLocaleString('ru-RU')}</Text>
							<CurrencyIcon icon={config.icon} size="md" />
						</Fragment>
					);
				})}
			</StyledPlayerStatsContainer>
		</StyledContainer>
	);
};

export { ShopBalance };
